export const getMenuIdFromUrl = (url) => {
    const result = url?.match(/\?.*menuId=([^&#]*)/);
    return result && result.length > 1 ? result[1].toLowerCase() : "";
};
export const getVisIdFromUrl = (url) => {
    const menuIdRegexMatch = /\?.*visid[^=]*=([^&#]*)/i;
    const result = menuIdRegexMatch.exec(url);
    return result ? result[1] : null;
};
export const updateQueryStringParameter = (url, key, value) => {
    if (!url) {
        return "";
    }
    const regex = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = url.indexOf("?") !== -1 ? "&" : "?";
    if (url.match(regex)) {
        return url.replace(regex, "$1" + key + "=" + value + "$2");
    }
    else {
        return url + separator + key + "=" + value;
    }
};
export const getVisIdFromInitialUrl = (url) => {
    url = url.toLowerCase();
    // provide a dummy base URL to ensure that relative URLs can be parsed without error
    const urlParams = new URL(url, 'http://anyorigin').searchParams;
    const urlVisId = getVisIdFromParams(urlParams);
    const initialUrl = urlParams.get("initialurl") || "";
    const initialUrlParams = new URL(initialUrl, 'http://anyorigin').searchParams;
    const initialUrlVisId = getVisIdFromParams(initialUrlParams);
    return initialUrlVisId || urlVisId;
};
const getVisIdFromParams = (params) => {
    const menuVisId = params.get("menuvisid");
    const visId = params.get("visid");
    return parseInt((menuVisId || visId), 10);
};
